var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 155.05 145.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#c3e2da;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 54.71,
    cy: 58.93,
    r: 8.08
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 68.52,
    cy: 77.75,
    r: 8.08
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 91.44,
    cy: 8.08,
    r: 8.08
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 52.35,
    cy: 10.97,
    r: 8.08
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 33.77,
    cy: 56.91,
    r: 8.08
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8.08,
    cy: 93.91,
    r: 8.08
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 8.11,
    cy: 54.17,
    r: 8.08
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 24.13,
    cy: 28.08,
    r: 8.08
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 111.13,
    cy: 50.08,
    r: 8.08
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 115.11,
    cy: 29.89,
    r: 6.07
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 133.44,
    cy: 54.17,
    r: 6.07
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 104.02,
    cy: 68.44,
    r: 6.07
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 89.94,
    cy: 50.37,
    r: 6.07
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 49.54,
    cy: 37.97,
    r: 6.07
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 30.72,
    cy: 109.49,
    r: 6.07
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 29.66,
    cy: 75.74,
    r: 6.07
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 6.1,
    cy: 74.98,
    r: 6.07
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 48.29,
    cy: 128.58,
    r: 6.07
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 65.37,
    cy: 110.52,
    r: 6.07
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 97.95,
    cy: 84.8,
    r: 6.07
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 85.76,
    cy: 104.45,
    r: 6.07
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 143.01,
    cy: 32.37,
    r: 6.07
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 69.59,
    cy: 35.43,
    r: 8.08
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 93.07,
    cy: 29.11,
    r: 8.08
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 47.46,
    cy: 92.88,
    r: 8.08
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 127.37,
    cy: 72.22,
    r: 8.08
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 60.7,
    cy: 141.2,
    r: 3.99
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 33.8,
    cy: 124.88,
    r: 3.99
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 28.26,
    cy: 94.62,
    r: 3.99
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 18.85,
    cy: 67.01,
    r: 3.99
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22.84,
    cy: 44.54,
    r: 3.99
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 43.47,
    cy: 24.69,
    r: 3.99
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 73.57,
    cy: 56.91,
    r: 3.99
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 85.76,
    cy: 68.18,
    r: 3.99
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 83.35,
    cy: 86.88,
    r: 3.99
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 68.86,
    cy: 95.14,
    r: 3.99
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 50.04,
    cy: 109.13,
    r: 3.99
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 66.22,
    cy: 125.37,
    r: 3.99
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.08,
    cy: 86.09,
    r: 3.99
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 136.52,
    cy: 85.83,
    r: 3.99
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 147.08,
    cy: 68.91,
    r: 3.99
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 112.38,
    cy: 10.97,
    r: 3.99
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 48.08,
    cy: 75.91,
    r: 3.99
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 68.86,
    cy: 17.03,
    r: 3.99
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 73.57,
    cy: 3.99,
    r: 3.99
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 127.37,
    cy: 17.87,
    r: 3.99
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 129.53,
    cy: 37.46,
    r: 3.99
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 151.06,
    cy: 54.17,
    r: 3.99
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 99.52,
    cy: 100.47,
    r: 3.99
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 33.55,
    cy: 11.66,
    r: 3.99
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "61.79 141.63 59.61 140.76 64.89 127.5 47.95 130.43 32.78 125.79 29.3 107.67 50.06 107.96 64.49 109.27 68.86 92.72 86.53 103.85 98.27 99.67 96.9 85.48 83.13 88.12 66.2 77.7 84.74 67.4 88.56 51.67 73.74 58.07 52.4 61.2 68.83 34.42 92.93 27.94 116.53 28.77 112.22 50.5 105.31 68.35 114.32 84.15 126.8 71.13 149.45 67.32 137.51 86.45 135.52 85.21 144.71 70.5 127.95 73.31 113.84 88.04 102.72 68.54 110 49.75 113.7 31.01 93.2 30.29 70.34 36.44 57.01 58.15 73.25 55.77 91.95 47.64 86.77 68.95 70.84 77.8 83.58 85.65 98.99 82.7 100.77 101.26 86.25 106.44 70.31 96.4 66.25 111.78 49.93 110.3 32.14 110.05 34.82 123.97 48.1 128.02 68.61 124.48 61.79 141.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "152.69 55.35 133.3 55.34 112.24 52.76 112.52 50.43 133.52 53 149.44 53 143.03 33.87 129.92 38.56 129.13 36.35 144.5 30.86 152.69 55.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "115.93 30.73 114.29 29.05 125.33 18.23 111.89 12.03 112.87 9.9 129.4 17.52 115.93 30.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.42 35.5 67.3 16.98 88.76 8.52 73.32 5.13 73.82 2.84 96.77 7.87 69.74 18.54 70.76 35.36 68.42 35.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "53.56 59.17 49.25 38.84 19.73 27.67 42.77 23.63 50.15 12.22 33.6 12.83 33.51 10.49 54.56 9.71 44.18 25.76 28.54 28.5 51.28 37.1 55.85 58.69 53.56 59.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "49.26 96.15 30.63 76.59 11.18 92.85 28.31 93.45 28.22 95.8 4.99 94.98 30.81 73.38 46.91 90.29 46.91 74.73 54.47 57.84 56.61 58.8 49.26 75.23 49.26 96.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6.72 75.98 5.48 73.99 17.1 66.73 5.67 52.81 23.09 43.06 33.76 55.13 49.38 37.2 51.15 38.74 33.77 58.68 22.59 46.03 9.26 53.49 20.6 67.3 6.72 75.98"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSmall);
export default __webpack_public_path__ + "static/media/logo_small.db672d505a2f3298e231beca7a86c9ab.svg";
export { ForwardRef as ReactComponent };